import React, { useState } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { FaMoon, FaSun } from 'react-icons/fa';

const navLinks = [
  { href: '#home', label: 'Home' },
  { href: '#techstack', label: 'Tech Stack' },
  { href: '#projects', label: 'Projects' },
  { href: '#coding', label: 'Coding Profiles' },
  { href: '#contact', label: 'Contact' },
];

const NavbarComponent = ({ theme, setTheme }) => {
  const [expanded, setExpanded] = useState(false);
  const [active, setActive] = useState('home');

  const handleThemeToggle = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  const handleNavClick = (href) => {
    setActive(href.replace('#', ''));
    setExpanded(false);
  };

  return (
    <Navbar
      expand="lg"
      bg={theme}
      variant={theme}
      className="sticky-navbar premium-navbar py-2"
      fixed="top"
      expanded={expanded}
      style={{ boxShadow: '0 2px 18px rgba(47,128,237,0.07)', fontFamily: 'Inter, Poppins, Roboto, Open Sans, Arial, sans-serif', transition: 'background 0.4s, box-shadow 0.4s' }}
    >
      <Container>
        <Navbar.Brand href="#home" className="navbar-branding fw-bold d-flex align-items-center gap-2" style={{ fontSize: '1.35rem', letterSpacing: '0.03em' }}>
          <span className="navbar-logo-gradient">Utkarsh Srivastava</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded((prev) => !prev)} />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center gap-2 premium-nav">
            {navLinks.map((link) => (
              <Nav.Link
                key={link.href}
                href={link.href}
                className={`premium-nav-link px-3 py-1 ${active === link.href.replace('#', '') ? 'active' : ''}`}
                onClick={() => handleNavClick(link.href)}
                style={{ fontWeight: 500, fontSize: '1.04em', letterSpacing: '0.01em', borderRadius: '10px', transition: 'background 0.2s, color 0.2s' }}
              >
                {link.label}
              </Nav.Link>
            ))}
            <Button variant="outline-secondary" className="ms-2 theme-toggle-btn" onClick={handleThemeToggle} aria-label="Toggle theme" style={{ borderRadius: '50%', padding: '0.45em 0.7em', fontSize: '1.1em', border: 'none', boxShadow: '0 1px 4px rgba(47,128,237,0.08)' }}>
              {theme === 'dark' ? <FaSun /> : <FaMoon />}
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarComponent;
